import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";

import MenuItem from "../outlet-components/MenuItem";
import OutletWrapper from "../outlet-components/OutletWrapper";
import ProgressBar from "../outlet-components/ProgressBar";
import ConfirmDelete from "../outlet-components/ConfirmDelete";
import {FaChevronRight, FaTrashAlt} from "react-icons/fa";
import {Card} from "react-bootstrap";
import {Navigate, Redirect} from "react-router-dom";

export default function Menu(props) {
    const [position, setPosition] = useState('top')
    const [redirectTo, setRedirectTo] = useState(false)
    const redirectToNew = async ()=>{
        const path = await props.addInstance()
       // console.log(path)
        setRedirectTo(path)
    }

    useEffect(()=>{
        setPosition('')
    },[])

    if (redirectTo){
        return <Navigate to={redirectTo}/>
    }

    return <OutletWrapper
        title={props.title}
        back={props.back}
        onEdit={props?.onEdit}
        progress={props?.progress}
        editing={props.editing}
    >
        {
            props?.progress === 100 && (
                <div className="d-flex justify-content-center align-items-center border-bottom text-success">
                    <h5 className="my-3  px-4">Section Completed!</h5>
                </div>
            )
        }
        <div className={` question-transition ${position}`}>
            <div className="mt-2 d-flex flex-column gap-2">
                {
                    props.items.map((item, index) => {
                        //console.log(item.link)
                        return (
                            <div key={'k' + item.link} className={`transitionable delay-${index + 2}`}>
                                <MenuItem
                                    id={item.index}
                                    link={item.link}
                                    delay={index}
                                    progress={item.progress}
                                    title={item.title}
                                    editing={props?.editing}
                                    remove={props?.removeInstance}
                                />
                            </div>
                        )
                    })
                }
                {
                    props?.addInstance && (
                        <div className={`transitionable delay-${props.items.length}`}>
                            <MenuItem editing={props?.editing} add={redirectToNew} title={props.addText}/>
                        </div>

                    )
                }
            </div>
        </div>
    </OutletWrapper>
}
Menu.propTypes = {
    //section: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
    back: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    editing: PropTypes.bool,
    //report up that edit has been clicked
    onEdit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    progress: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};